import { lazy } from 'react';
import { D as DefaultTranslationComp } from './en-US-D4hNtu1h.js';

/* eslint-disable quotes, quote-props, comma-dangle, max-len */
// eslint-disable-next-line @typescript-eslint/no-unused-vars

const translationImports = {
  'ar-AE': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--ar-AE" */'./ar-AE-BMPp-P0G.js'),
  'de-DE': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--de-DE" */'./de-DE-DJXFbTtm.js'),
  'en-AU': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--en-AU" */'./en-AU-Cj11ajWW.js'),
  'en-CA': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--en-CA" */'./en-CA-DDrcmlbF.js'),
  'en-GB': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--en-GB" */'./en-GB-DOHWcdqx.js'),
  'en-IN': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--en-IN" */'./en-IN-DctEYP16.js'),
  'en-SG': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--en-SG" */'./en-SG-BblDzNdI.js'),
  'es-CO': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--es-CO" */'./es-CO-C47j2g1o.js'),
  'es-ES': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--es-ES" */'./es-ES-DUCLgPoy.js'),
  'es-MX': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--es-MX" */'./es-MX-BUv3gzFf.js'),
  'fr-CA': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--fr-CA" */'./fr-CA-GDeLGBT3.js'),
  'fr-FR': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--fr-FR" */'./fr-FR-BwgCjLcM.js'),
  'hi-IN': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--hi-IN" */'./hi-IN-Bh3Vmr5L.js'),
  'it-IT': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--it-IT" */'./it-IT-Q_gybakr.js'),
  'ja-JP': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--ja-JP" */'./ja-JP-DvX_VJ9V.js'),
  'ko-KR': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--ko-KR" */'./ko-KR-B0Z1CakI.js'),
  'nl-NL': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--nl-NL" */'./nl-NL-ieTPytz_.js'),
  'pl-PL': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--pl-PL" */'./pl-PL-04PCNCJ0.js'),
  'pt-BR': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--pt-BR" */'./pt-BR-DPbAp8-e.js'),
  'sv-SE': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--sv-SE" */'./sv-SE-Dtb_tDlF.js'),
  'ta-IN': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--ta-IN" */'./ta-IN-D7_IVJUi.js'),
  'th-TH': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--th-TH" */'./th-TH-C6XqD19L.js'),
  'tr-TR': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--tr-TR" */'./tr-TR-B9uI4q-F.js'),
  'vi-VN': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--vi-VN" */'./vi-VN-BFgaZn9f.js'),
  'zh-CN': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--zh-CN" */'./zh-CN-wdis1pmf.js'),
  'zh-TW': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--zh-TW" */'./zh-TW-Bgb4QPO7.js')
};
const translationComps = Object.entries(translationImports).reduce((acc, [localCode, importFn]) => ({
  ...acc,
  [localCode]: /*#__PURE__*/lazy(importFn)
}), {});
function getTranslationComponent(locale) {
  return {
    component: locale && locale in translationComps ? translationComps[locale] : DefaultTranslationComp,
    locale: locale && locale in translationComps ? locale : 'en-US',
    translationImports
  };
}

export { getTranslationComponent as g };
//# sourceMappingURL=index-IUTEEO4X.js.map
